import { render, staticRenderFns } from "./CurrentInventory.vue?vue&type=template&id=05864749&"
import script from "./CurrentInventory.vue?vue&type=script&lang=js&"
export * from "./CurrentInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports